import { render, staticRenderFns } from "./informationDetailsSub.component.vue?vue&type=template&id=6fcdfb12"
import script from "./informationDetailsSub.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetailsSub.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports